import React from "react";
import ReportCard from "../../components/ui/ReportCard";
import { ArrowUpIcon } from "@chakra-ui/icons";

export default function PendingReports() {
  return (
    <ReportCard text={50} icon={<ArrowUpIcon />} title="Pending Reports" />
  );
}
